import { useState } from 'react';

import type { ExamPublishStudent } from '../types/exam';

export function usePublicationManagement(_publicationId: number) {
  const publication = null;

  const [editForm, setEditForm] = useState({
    startDate: '',
    endDate: '',
    maxAttempts: 3,
    durationMinutes: 120,
    allowExtraAttempt: false,
  });

  const updateEditForm = <K extends keyof typeof editForm>(key: K, value: (typeof editForm)[K]) => {
    setEditForm(prev => ({ ...prev, [key]: value }));
  };

  const saveEdit = () => {};

  const deletePublication = () => {};

  const expandDuration = (_newEndDate: string) => {};

  const addStudents = (_personIds: number[]) => {};

  const removeStudent = (_studentId: number) => {};

  const availableStudents: readonly ExamPublishStudent[] = [];

  return {
    publication,
    editForm,
    updateEditForm,
    saveEdit,
    deletePublication,
    expandDuration,
    addStudents,
    removeStudent,
    availableStudents,
  } as const;
}
